import React from 'react'
import Image from "next/legacy/image"
import { Box, Flex, Image as ImageComponent, Text } from '@chakra-ui/react'

export const RatingBanner = ({ ratingHeader, review, reviewer, ratingImg }) => {
    return (
        (<Flex bg={"brand.100"} px={{ base: "15px", lg: "122px" }} flexDir={{ base: "column", md: "row" }} justifyContent={"space-between"} mx={{ base: "-15px", lg: "inherit" }}>
            <Flex w={{ md: "50%" }}>
                <ImageComponent
                    src={ratingImg}
                    // width={"1000%"} height={"1000%"}
                    placeholder={"blur"}
                    w={["100%", "350px", "100%"]} mx={"auto"}
                    objectFit={"contain"}
                    blurDataURL={<Image
                        src={"/images/newLanding/adsPlaceholder.png"}
                        style={{
                            maxWidth: "100%",
                            height: "auto"
                        }} />}
                />
            </Flex>
            <Flex flexDir={"column"} justifyContent={"center"} py={"80px"} w={{ md: "40%" }}>
                <ImageComponent src={"/images/newLanding/ratingsIcons.svg"} height={"30px"} width={"100px"} mx={["auto", "auto", "0"]} />

                <Text mt={"28px"} fontWeight={"500"} textAlign={["center", "center", "start"]} fontSize={"18px"}>“{ratingHeader}”</Text>

                <Text
                    color={"gray.500"} fontSize={{ base: "14px", lg: "16px" }} fontWeight={"500"}
                    lineHeight={{ base: "24px", lg: "28px" }} my={"32px"}
                    textAlign={{ base: "center", md: "left" }}
                >
                    {review}
                </Text>

                <Text fontWeight={"500"} textAlign={["center", "center", "start"]} fontSize={"18px"}>{reviewer}</Text>

                <Box my={"20px"} borderTopWidth={"1px"} borderTopColor={"gray.300"} />

            </Flex>
        </Flex >)
    );
}
